<p-confirmDialog #cd header="Confirmation" icon="fa ui-icon-question" [style]="{ width: '425px' }">
  <p-footer>
    <button type="button" pButton label="No, Cancel" (click)="cd.reject()"></button>
    <button
      type="button"
      pButton
      class="ui-button ui-button-danger"
      label="Yes, Remove"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>

<div
  *ngIf="!(supplierJobStoreService.loading$ | async) && supplierJobStoreService.totalRecords == 0"
>
  <div class="no-jobs">
    <div
      style="
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: space-around;
        flex-grow: 1;
        flex-direction: column;
      "
    >
      <div class="no-jobs-icon">
        <i class="fa fa-exclamation-circle"></i>
      </div>
    </div>
    <div style="display: flex; flex-wrap: wrap; grid-gap: 15px; flex-grow: 99">
      <div style="flex-grow: 9">
        <div class="no-jobs-line-1 pt-2">Sorry, no jobs in here right now</div>
        <div class="no-jobs-line-2 pb-2">Don't worry, more opportunities are coming soon!</div>
      </div>
      <!--      <div-->
      <!--        class="no-jobs-cta"-->
      <!--        *ngIf="!inAvailableJobsTab()"-->
      <!--        style="text-align: center; display: flex; align-items: center; justify-content: center"-->
      <!--      >-->
      <!--        <div class="no-jobs-line-3">-->
      <!--          <div (click)="goToAvailableJobs()" class="link-style cursor-pointer">-->
      <!--            All Available Jobs <i class="fa fa-arrow-right"></i>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</div>

<div class="grid h-100">
  <div class="col-12 supplier-job-list-view scroll-container h-100" style="overflow-y: auto">
    <ng-container *ngIf="supplierJobStoreService.jobs | async as result">
      <supplier-jobs-inbox-item
        (changedVisibility)="changedVisibility($event, job.id)"
        [job]="job"
        [inboxType]="inboxType"
        *ngFor="let job of result"
        [attr.data-routeId]="job.id"
        (handBackJobEvent)="handBackJob($event)"
      ></supplier-jobs-inbox-item>
    </ng-container>
    <p-progressBar
      *ngIf="supplierJobStoreService.loading$ | async"
      mode="indeterminate"
      class="ui-progressbar-indeterminate"
    ></p-progressBar>
  </div>
</div>

<!--<edit-task-schedule-dialog-->
<!--  *ngIf="selectedEditScheduleTask"-->
<!--  [(visible)]="editTaskScheduleVisible"-->
<!--  [jobId]="selectedEditScheduleTask.jobId"-->
<!--  (scheduleUpdated)="onScheduleUpdated()"-->
<!--&gt;</edit-task-schedule-dialog>-->
